export default __webpack_public_path__ + "static/media/gunbot-interface.9976daa2.png";